document.addEventListener('click', function(e) {
  var btn = e.target.closest('xo-cart-quantity-minus');
  if (!btn) return;
  var product = btn.closest('xo-product');
  if (!product || !product.hasAttribute('xo-line')) return;
  var input = btn.closest('xo-cart-quantity');
  if (!input) return;
  input = input.querySelector('input');
  if (!input || parseInt(input.value, 10) > 1) return;
  e.stopPropagation();
  var remove = product.querySelector('xo-cart-remove');
  if (remove) remove.click();
}, true);
